import type { RouteObject } from 'react-router';
import { paths } from '@/config/paths';
import type { RouteHandle } from '@/shared/routing';

/** Public (guest-only) routes, rendered inside the auth layout. */
export const createAuthRoutes = (): RouteObject[] => [
  {
    path: paths.login,
    handle: { title: 'Sign in' } satisfies RouteHandle,
    lazy: { Component: async () => (await import('./pages/SignInPage')).SignInPage },
  },
  {
    path: paths.password,
    handle: { title: 'Enter password' } satisfies RouteHandle,
    lazy: { Component: async () => (await import('./pages/PasswordPage')).PasswordPage },
  },
  {
    path: paths.microsoft,
    handle: { title: 'Sign in with Microsoft' } satisfies RouteHandle,
    lazy: { Component: async () => (await import('./pages/MicrosoftPage')).MicrosoftPage },
  },
  {
    path: paths.forgotPassword,
    handle: { title: 'Reset password' } satisfies RouteHandle,
    lazy: {
      Component: async () => (await import('./pages/ForgotPasswordPage')).ForgotPasswordPage,
    },
  },
];
